import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserService } from "src/app/shared/user.service";
import { Notification } from "./notification.model";
import { resolve } from "path";
import { rejects } from "assert";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  loggedinUser: any;
  ContractType: any;
  Notification: Notification;
  private messageSource = new BehaviorSubject("");
  currentMessage = this.messageSource.asObservable();
  NotificationList: Notification[];
  contracttypeBaseUrl: String;
  contractApiURL: string;
  userCreationConfirmationAlert: boolean = false;
  alertMessage: string = "";

  constructor(private http: HttpClient, public userService: UserService) {
    this.contracttypeBaseUrl = environment.contractTypeApiURL;
    this.contractApiURL = environment.contractApiURL;
  }

  getContractRoles() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractApiURL +
          "/get-all-contract-roles"
        )
        .toPromise()
        .then((res: any) => {
          resolve(res.body);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getNotificationData() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractApiURL +
          "/getAllNotificationTemplates/"+this.userService.loggedinUser.tenantId
        )
        .toPromise()
        .then((res: any) => {
          resolve(res.body);

        }).catch((error) => {
          reject(error);
        })
    });
  }

  getContractMetadata(id) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractApiURL + "/getNotificationMetadata?tenantId=" +
          this.userService.loggedinUser.tenantId + (id ? "&contractTypeId=" + id : '')
        )
        .toPromise()
        .then((res: any) => {
          resolve(res.body);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getNotificationTrigger() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractApiURL + "/getAllNotificationActions"
        )
        .toPromise()
        .then((res: any) => {
          resolve(res.body);
        }).catch((error) => {
          reject(error);
        })
    });
  }


  toggleNotificationStatus(id) {
    return new Promise((resolve, reject) => {

      this.http
        .put(this.contractApiURL +
          `/change-notification-status/${id}/${this.userService.loggedinUser.id}`, null)
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });;
    });
  }

  getContractType() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/ContractType?tenantId=" +
          this.userService.loggedinUser.tenantId
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        })
    });
  }

  getNotificationDetails(notificationId: number) {
    /*let that = this;*/
    return new Promise((resolve, reject) => {
      this.http
        .get(this.contractApiURL + "/get-notification-by-id/" + notificationId)
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  saveNotification(data) {
    const emailTo = Array.isArray(data.sendEmailTo) ? data.sendEmailTo?.map(element => ({
      contractRoleId: element,
      recipientType: 'SEND'
    })) : [];

    const ccTo = Array.isArray(data.ccEmailTo) ? data.ccEmailTo?.map(element => ({
      contractRoleId: element,
      recipientType: 'CC'
    })) : [];

    const userId = Array.isArray(data.users) ? data.users?.map(element => ({
      userId: element,
      recipientType: 'SEND'
    })) : [];

    const ccUserId = Array.isArray(data.ccUsers) ? data.ccUsers?.map(element => ({
      userId: element,
      recipientType: 'CC'
    })) : [];

    const req = {
      notificationEntity: {
        notificationName: data.notificationName,
        notificationType: data.notificationType,
        contractTypeId: data.contractTypeId,
        emailSubject: data.emailSubject,
        emailBody: data.emailBody,
        notificationActionId: data.actionId,
        tenantId:this.userService.loggedinUser.tenantId,
        createdBy: this.userService.loggedinUser.id,
        createdOn: new Date()
      },
      contractRoleIds: [...emailTo, ...ccTo],
      userIds: [...userId, ...ccUserId]

    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': "application/json",
      }),
    };
    return this.http.post(this.contractApiURL + "/createNotification", req,
      httpOptions).toPromise();
  }


  async updateNotification(data, id) {
    let contractSendRoleIds = [];
    let contractCCRoleIds = [];
    let contractUsers = [];
    let contractCCUsers = [];
    await this.getNotificationDetails(id).then((res: any) => {
      if (res.body[0]?.sendEmailToRole) {
        contractSendRoleIds = res.body[0]?.sendEmailToRole
          .map(entry => ({ id: entry.id, contractRoleId: entry.contractRoleId }));
      }
      if (res.body[0]?.ccEmailToRole) {
        contractCCRoleIds = res.body[0]?.ccEmailToRole
          .map(entry => ({ id: entry.id, contractRoleId: entry.contractRoleId }));
      }
      if (res.body[0]?.users) {
        contractUsers = res.body[0]?.users
          .filter(entry => entry.recipientType === 'SEND')
          .map(entry => entry.userId);
      }
      if (res.body[0]?.users) {
        contractCCUsers = res.body[0]?.users
          .filter(entry => entry.recipientType === 'CC')
          .map(entry => entry.userId);
      }
    });

    contractSendRoleIds.filter(role => !data.sendEmailTo.includes(role.contractRoleId));

    contractCCRoleIds.filter(role => !data.ccEmailTo.includes(role.contractRoleId));

    contractUsers.filter(user => !data.users.includes(user.userId));

    contractCCUsers.filter(user => !data.users.includes(user.userId));


    contractSendRoleIds.forEach(role => {
      this.http
        .delete(
          this.contractApiURL + `/delete-notification-role/${role.id}/${id}`
        ).toPromise()
    })

    contractCCRoleIds.forEach(role => {
      this.http
        .delete(
          this.contractApiURL + `/delete-notification-role/${role.id}/${id}`
        ).toPromise()
    })

    contractUsers.forEach(user => {
      this.http
        .delete(
          this.contractApiURL + `/delete-notification-user/${user}/${id}`
        ).toPromise()
    })

    const emailTo = data.sendEmailTo.map(element => ({
      contractRoleId: element,
      recipientType: 'SEND'
    }));

    const ccTo = Array.isArray(data.ccEmailTo) ? data.ccEmailTo.map(element => ({
      contractRoleId: element,
      recipientType: 'CC'
    })) : [];

    const userId = Array.isArray(data.users) ? data.users.map(element => ({
      userId: element,
      recipientType: 'SEND'
    })) : [];

    const ccUserId = Array.isArray(data.ccUsers) ? data.ccUsers.map(element => ({
      userId: element,
      recipientType: 'CC'
    })) : [];

    const req = {
      notificationEntity: {
        notificationName: data.notificationName,
        notificationType: data.notificationType,
        contractTypeId: data.contractTypeId,
        emailSubject: data.emailSubject,
        emailBody: data.emailBody,
        notificationActionId: data.actionId,
        updatedBy: this.userService.loggedinUser.id,
        updatedOn: new Date()
      },
    
      contractRoleIds: [...emailTo, ...ccTo],
      userIds: [...userId, ...ccUserId]
    }
    console.log(req,'update')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': "application/json",
      }),
    };
    return this.http.put(this.contractApiURL + `/updateNotification?notificationId=${id}`, req,
      httpOptions).toPromise();
  }
  // editNotification(data) {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //     })
  //   };
  //   data.updatedOn = new Date();
  //   data.updatedBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
  //   data.createdOn = new Date();
  //   data.createdBy = this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName;
  //   return new Promise<void>((resolve, reject) => {
  //     this.http.put(
  //       this.contractApiURL + "/updateNotification", data, httpOptions
  //     ).toPromise()
  //       .then((res: any) => {
  //         console.log(res, 'eerer')
  //         resolve(res)
  //       }).catch((error) => {
  //         reject(error);
  //       });
  //   })

  // }
  getSendTo() {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contractApiURL +
          "/tenants/" +
          this.userService.loggedinUser.tenantId +
          "/users"
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        });
    });
  }

  getContractTypeName(contaractTypeID: number) {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          this.contracttypeBaseUrl +
          "/ContractType/" +
          contaractTypeID +
          "?tenantId=" +
          this.userService.loggedinUser.tenantId
        )
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  deleteNotification(notificationId: number) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(
          this.contractApiURL + "/delete-notification/" + notificationId
        )
        .toPromise()
        .then((res) => {
          resolve(notificationId);
        }).catch((error) => {
          reject(error);
        });
    });
  }
}
